module.exports = __webpack_public_path__ + "static/img/fsjbh5.4e13ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fsjbh5.png
// module id = NjSF
// module chunks = 1